import React from 'react';
import { FormattedMessage } from 'react-intl';
import * as messages from './messages';

import { ZoneValues } from '../../enums/zone-values';
import { WarehouseStatus } from './filter-options/options/warehouse-status';
import { PickBatchExceptionType } from '../../enums/pick-batch-exception-type';

const buildCriterionArgumentObject = (id, displayMessage, value) => {
  return {
    id,
    displayName: <FormattedMessage {...displayMessage} />,
    value,
  };
};

export const residentialEnum = 'R';
export const commercialEnum = 'C';
const getResidentialOrCommercialArgument = (keyName) => (keyName === 'residential' ? residentialEnum : commercialEnum);
const getWarehouseStatusValue = (keyName, index) => {
  if (keyName === WarehouseStatus.values.NoStatus) {
    return;
  }
  return index - 1;
};

export const staticCriteriaArguments = {
  addressValidationStatus: Object.keys(messages.AddressValidationStatusMessages).map((key) =>
    buildCriterionArgumentObject(key, messages.AddressValidationStatusMessages[key], key),
  ),
  allocationStatus: Object.keys(messages.AllocationStatusMessages).map((key) =>
    buildCriterionArgumentObject(key, messages.AllocationStatusMessages[key], key === 'allocated'),
  ),
  destination: Object.keys(messages.DestinationMessages).map((key) =>
    buildCriterionArgumentObject(key, messages.DestinationMessages[key], key === 'domestic'),
  ),
  gift: Object.keys(messages.GiftMessages).map((key) => buildCriterionArgumentObject(key, messages.GiftMessages[key], key === 'isGift')),
  packingSlip: Object.keys(messages.PackingSlipMessages).map((key) =>
    buildCriterionArgumentObject(key, messages.PackingSlipMessages[key], key === 'printed'),
  ),
  warehouseStatus: Object.keys(messages.WarehouseStatusMessages).map((key, index) =>
    buildCriterionArgumentObject(key, messages.WarehouseStatusMessages[key], getWarehouseStatusValue(key, index)),
  ),
  pickingException: [
    buildCriterionArgumentObject('notEnoughStock', messages.PickingExceptionMessages.notEnoughStock, PickBatchExceptionType.NotEnoughStock),
    buildCriterionArgumentObject('productDamaged', messages.PickingExceptionMessages.productDamaged, PickBatchExceptionType.ProductDamaged),
    buildCriterionArgumentObject(
      'productNotFound',
      messages.PickingExceptionMessages.productNotFound,
      PickBatchExceptionType.ProductNotFound,
    ),
    buildCriterionArgumentObject('other', messages.PickingExceptionMessages.other, PickBatchExceptionType.Other),
  ],
  pickList: Object.keys(messages.PickListMessages).map((key) =>
    buildCriterionArgumentObject(key, messages.PickListMessages[key], key === 'printed'),
  ),
  residentialOrCommercial: Object.keys(messages.ResidentialOrCommericalMessages).map((key) =>
    buildCriterionArgumentObject(key, messages.ResidentialOrCommericalMessages[key], getResidentialOrCommercialArgument(key)),
  ),
  zone: ZoneValues.map((zone) => ({
    displayName: zone.toString(),
    value: zone,
  })),
  rate: Object.keys(messages.RateMessages).map((key) => buildCriterionArgumentObject(key, messages.RateMessages[key], key === 'hasRate')),
};
